import { Link } from "react-router-dom";

export function generateShortItemCode() {
  const timestamp = Date.now().toString(36); // e.g. 'lk8m1l4'

  // Random base36 chars for extra safety
  const randomPart = Math.random().toString(36).substring(2, 6); // 4 random chars

  // Combine, then take exactly 7 chars
  return (timestamp + randomPart).substring(0, 7).toUpperCase();
}

// Example Output: 'k1o9xv4'

export function formatDate(input) {
  const d = new Date(input);
  if (isNaN(d)) return "";
  const dd = String(d.getUTCDate()).padStart(2, "0");
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  const yyyy = d.getUTCFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

export const getTodayDate = () => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = today.getFullYear();
  return `${day}/${month}/${year}`;
};

export const convertToDateInputFormat = (ddmmyyyy) => {
  const [day, month, year] = ddmmyyyy.split("/");
  return `${year}-${month}-${day}`;
};

export function threeDecimal(input) {
  return (+input || 0)?.toFixed(3);
}

export function twoDecimal(input) {
  return (+input || 0)?.toFixed(2);
}

export function intt(input) {
  return +input || 0;
}

export const pakkiPaymentList = [
  { label: "Cash", value: "Cash" },
  { label: "Card", value: "Card" },
  { label: "UPI", value: "UPI" },
  { label: "Cheque", value: "Cheque" },
  { label: "RTGS", value: "RTGS" },
  { label: "Deduct From Advance", value: "Deduct From Advance" },
];
export const kachhiPaymentList = [
  { label: "Cash", value: "Cash" },
  { label: "Metal", value: "Metal" },
  { label: "Metal To Cash", value: "Metal To Cash" },
  { label: "Cash To Metal", value: "Cash To Metal" },
  { label: "Deduct From Advance", value: "Deduct From Advance" },
];



export const designPayload = (payload)=>{

  return payload?.looseStones?.map((item)=>{
    return{
      ...item,
      vendor:payload?.vendor,
      branch:payload?.branch,
    }
  })

}

export function renderHighlightWord(text, highlight = "SwithIn") {
  if (!text?.action || !highlight) return text?.action;

  const regex = new RegExp(`(${highlight})`, "gi");
  const parts = text?.action?.split(regex);

  return parts.map((part, idx) =>
    part.toLowerCase() === highlight.toLowerCase() ? (
      <>
      <Link to={text?.url} key={idx} className="text-[#9481ce] font-semibold cursor-pointer">
        {part}
      </Link>
      </>
    ) : (
      <span key={idx}>{part}</span>
    )
  );
}
